import SubstackChange1 from 'src/components/subStackChange';
import * as React from 'react';
export default {
  SubstackChange1,
  React
};